import { render, staticRenderFns } from "./BenefitsGrid.vue?vue&type=template&id=0619e082&scoped=true"
import script from "./BenefitsGrid.vue?vue&type=script&lang=js"
export * from "./BenefitsGrid.vue?vue&type=script&lang=js"
import style0 from "./BenefitsGrid.vue?vue&type=style&index=0&id=0619e082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0619e082",
  null
  
)

export default component.exports